import styled from "styled-components";

export const GeoBlock = styled.div`
  width: 375px;
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  @media (max-width: 475px) {
    width: 90vw;
  }
`;

export const Map = styled.div`
  width: 100%;
  height: 400px;
  border-radius: 30px 30px 0px 0px;
  background-color: #fff;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 76% 88%, 0 87%);
  @media (max-width: 475px) {
    height: 100vw;
  }
`;

export const Coordinate = styled.p`
  max-width: 320px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  text-transform: capitalize;
  @media (max-width: 375px) {
    font-size: 18px;
    line-height: 24px;
  }
`;
